import s from './SelectAddProposalTemplate.scss'
import { Container, Col, Row } from 'reactstrap'
import Select from 'react-select'
import { toTemplateSelect } from './serializers'
import { useLoading } from 'hooks'
import { makeGetRequest } from 'utils/api'

const SelectAddProposalTemplate = ({
  dealTemplates,
  templates,
  setSelectedGlobalTemplate,
  selectedGlobalTemplate,
  selectedDealTemplate,
  setSelectedDealTemplate,
  setEditedProposalTemplate
}) => {
  const [, withLoadingLocks] = useLoading()
  return (
    <>
      <Container>
        <Row>
          {dealTemplates.length > 0 ? (
            <Col lg="6">
              <div className={s.select}>
                <p>Saved Draft Proposals or Generated Proposals for this opportunity</p>
                <Select
                  value={selectedDealTemplate}
                  options={toTemplateSelect(dealTemplates)}
                  onChange={value => {
                    setSelectedDealTemplate(value)
                    setEditedProposalTemplate('')
                  }}
                  placeholder="Select a Draft or Generated Proposal"
                />
              </div>
            </Col>
          ) : (
            <Col lg="3" />
          )}
          <Col lg="6">
            <div className={s.select}>
              <p>Proposal Templates from your library or the company library</p>
              <Select
                value={selectedGlobalTemplate}
                options={toTemplateSelect(templates)}
                onChange={async value => {
                  const { content } = await withLoadingLocks(
                    makeGetRequest(`/v1/proposaltemplates/${value.value}`)
                  )
                  setSelectedGlobalTemplate({ ...value, content })
                  setEditedProposalTemplate('')
                }}
                placeholder="Select a Proposal Template"
                id="cy_template_select"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default SelectAddProposalTemplate
